var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiBedSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:bed-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.6667 13.3332V9.33317C22.6667 8.62593 22.3858 7.94765 21.8857 7.44755C21.3856 6.94746 20.7073 6.6665 20.0001 6.6665H12.0001C10.5334 6.6665 9.3334 7.8665 9.3334 9.33317V13.3332C7.86673 13.3332 6.52007 14.5332 6.66673 15.9998V22.6665H8.44007L9.3334 25.3332H10.6667L11.5601 22.6665H20.4401L21.3334 25.3332H22.6667L23.5601 22.6665H25.3334V15.9998C25.3334 15.2926 25.0524 14.6143 24.5524 14.1142C24.0523 13.6141 23.374 13.3332 22.6667 13.3332ZM20.0001 13.3332H12.0001V9.33317H20.0001V13.3332Z",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiBedSingle);
export default __webpack_public_path__ + "static/media/mdi_bed-single.ed00da58387e9a1b2030f4bc362dfd4f.svg";
export { ForwardRef as ReactComponent };